module.exports = __webpack_public_path__ + "img/icon_point_search.7b8c796d.svg";